import React from 'react';
import { Table as AntTable, Space, Avatar, Input ,Button } from 'antd';
import { useState,useRef } from "react";
import { UserOutlined,SearchOutlined } from '@ant-design/icons';
import { genNumberTable } from '../../../../function/genNumberTable';
import { USER_ROLE_MAPPING } from '../../../../data/constant';

const headerStyle = {
  color: '#525252',
};

const Table = ({ data, onEdit, onCopySettings, loading }) => {
  const [ setSearchText] = useState('');
  const [ setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns = [
    { 
      title: 'ลำดับ',
      align: 'center',  
      width: 60, 
      dataIndex: 'number',
      key: 'number',
      onHeaderCell: () =>{return {style:headerStyle}}
    },
    { 
      title: 'Name', 
      align: 'center', 
      dataIndex: 'companyName', 
      key: 'companyName',
      onHeaderCell: () =>{return {style:headerStyle}} ,
      ...getColumnSearchProps('companyName'),
    },
    {
      title: 'สี',
      align: 'center',
      dataIndex: 'themeColor',
      key: 'themeColor',
      width: 90,
      onHeaderCell: () =>{return {style:headerStyle}} ,
      render: (themeColor, record) => (
        <span
          style={{
            // โชว์บนพื้นเข้มเหมือน sidebar จริง จะได้เห็นว่าสีขาว/สีอ่อนอ่านออกมั้ย
            background: '#20232a',
            color: themeColor || '#ffffff',
            padding: '2px 10px',
            borderRadius: 4,
            fontWeight: 700,
            whiteSpace: 'nowrap',
          }}
        >
          {record.companyName || '-'}
        </span>
      ),
    },
    {
      title: 'Create Date',
      align: 'center',
      dataIndex: 'create_date',
      key: 'create_date',
      onHeaderCell: () =>{return {style:headerStyle}} ,
    },
    {
      title: 'Create By',
      align: 'center',
      dataIndex: 'create_by',
      key: 'create_by',
      onHeaderCell: () =>{return {style:headerStyle}} ,
    },
    { 
      title: 'การจัดการ',
      fixed: 'right',
      key: 'actions',
      align: 'center',
      render: (record) => (
        <Space size="middle">
          <div className="text-blue-500 cursor-pointer" onClick={() => onEdit(record)}>
            แก้ไข
          </div>
          {onCopySettings && (
            <div className="text-blue-500 cursor-pointer" onClick={() => onCopySettings(record)}>
              คัดลอกการตั้งค่า
            </div>
          )}
        </Space>
      ),
      onHeaderCell: () => ({ style: headerStyle }),
    }
  ];

  return ( 
    <div className='overflow-x-auto'>
      <AntTable 
        loading={loading}   
        className='border-1 rounded-lg border-gray-200' 
        dataSource={genNumberTable(data)}
        columns={columns}  
        pagination={{ pageSize: 8 }} 
        rowKey={'id'}
        scroll={{ x: 'max-content' }}  
      />
    </div>
  );
};

export default Table;
